import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const PeriodContext = createContext(null);

export const PeriodProvider = ({ children }) => {
  const [months, setMonths] = useState([]);
  const [asOf, setAsOf] = useState(null);
  const [period, setPeriod] = useState("MTD");
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]); // master list
  const [selectedProjects, setSelectedProjects] = useState([]); // [] = all

  useEffect(() => {
    Promise.all([
      api.get("/kpi/available-months"),
      api.get("/projects/all"),
    ]).then(([rm, rp]) => {
      const m = rm.data;
      setMonths(m);
      if (m.length) setAsOf(m[m.length - 1].value);
      setProjects(rp.data.projects);
    }).finally(() => setLoading(false));
  }, []);

  // Build common query suffix used by every KPI call
  const projectsQS = selectedProjects.length
    ? `&projects=${encodeURIComponent(selectedProjects.join(","))}`
    : "";

  return (
    <PeriodContext.Provider
      value={{
        months, asOf, setAsOf, period, setPeriod, loading,
        projects, selectedProjects, setSelectedProjects, projectsQS,
      }}
    >
      {children}
    </PeriodContext.Provider>
  );
};

export const usePeriod = () => useContext(PeriodContext);
